import BookingTab from './BookingTab'

export default BookingTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/index.js